import CheckIcon from '@mui/icons-material/Check';
import { Button } from '@efexteam/components';
import {
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { logoEfexInvoice } from '@/assets';
import useWhiteLabelService from '@/layout/login/hooks/useWhiteLabel.service';

interface IWelcomePage {
  nextFormStep: () => void;
}

const WelcomePage = ({ nextFormStep }: IWelcomePage) => {
  const { t } = useTranslation();
  const { whiteLabelState } = useWhiteLabelService();

  const companyRequirements = [
    t('regBusinessMessage1'),
    `${t('regBusinessMessage2')} ${t('onbOldDocument')}`,
    `${t('regBusinessMessage3')} ${t('onbOldDocument')}`,
    t('regBusinessMessage4'),
  ];

  return (
    <>
      <Typography variant="h4" className="text-center !mt-6">
        {t(
          whiteLabelState?.organizationID
            ? 'lngWelcomeWhiteLabel'
            : 'regWelcome'
        )}
        {!whiteLabelState?.organizationLogoURL && (
          <img
            src={logoEfexInvoice}
            alt="Efex"
            className="max-w-[150px] inline"
          />
        )}
      </Typography>
      <hr className="my-3 invisible" />
      <Typography variant="h6" className="text-center">
        {t('regWelcomeMessage')}
      </Typography>

      <hr className="my-5 invisible" />

      <Grid container spacing={2} className="justify-around my-6">
        <Grid item xs={12} lg={4}>
          <Paper className="p-3 h-full">
            <List>
              {companyRequirements.map((item) => (
                <ListItem key={item}>
                  <ListItemIcon>
                    <CheckIcon />
                  </ListItemIcon>
                  <ListItemText primary={item} />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
      <Grid item xs={12} className="flex justify-center">
        <Button
          appearance="primary"
          size="large"
          className="!mt-4"
          onClick={nextFormStep}
        >
          {t('regContinue')}
        </Button>
      </Grid>
    </>
  );
};

export default WelcomePage;
